@if (platform.isDesktop()) {
  @if (recording_service.active_state$ | async; as active) {
    @if (should_show_floating_active()) {
      @if (is_minimized()) {
        <div class="recording-chip-wrapper">
          <button
            type="button"
            class="recording-chip"
            [class.is-paused]="active.status === 'paused'"
            [class.is-error]="active.status === 'upload_failed' || active.status === 'failed'"
            [class.is-completed]="active.status === 'completed'"
            [matTooltip]="active.concept + ' · ' + statusLabel(active.status) + ' · ' + formatElapsed(active.elapsed_seconds)"
            (click)="expand()"
          >
            <span class="recording-chip-dot"></span>
            <mat-icon>{{ active.media_type === 'video' ? 'videocam' : 'mic' }}</mat-icon>
            <span class="recording-chip-time">{{ formatElapsed(active.elapsed_seconds) }}</span>
          </button>
          @if (shouldShowDismissOnMinimizedChip(active.status)) {
            <button
              mat-icon-button
              type="button"
              class="small-icon-button recording-chip-dismiss"
              matTooltip="Ocultar aviso (la grabación no se elimina)"
              (click)="closePopup(active.status, $event)"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      } @else {
        <div
          class="recording-popover"
          [class.is-paused]="active.status === 'paused'"
          [class.is-error]="active.status === 'upload_failed' || active.status === 'failed'"
          [class.is-completed]="active.status === 'completed'"
        >
          <div class="recording-popover-header">
            <mat-icon>{{ active.media_type === 'video' ? 'videocam' : 'mic' }}</mat-icon>
            <span class="recording-popover-title">{{ popoverTitle(active.status) }}</span>
            @if (canMinimize(active.status)) {
              <button
                mat-icon-button
                type="button"
                class="small-icon-button recording-minimize-button"
                matTooltip="Minimizar"
                (click)="minimize()"
              >
                <mat-icon>minimize</mat-icon>
              </button>
            }
            @if (!isLiveRecordingStatus(active.status)) {
              <button
                mat-icon-button
                type="button"
                class="small-icon-button recording-dismiss-button"
                matTooltip="Ocultar aviso (la grabación no se elimina)"
                (click)="closePopup(active.status)"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
          <div class="recording-info">
            <strong>{{ active.concept }}</strong>
            <span>{{ captureModeLabel(active) }} · {{ statusLabel(active.status) }} · {{ formatElapsed(active.elapsed_seconds) }}</span>
            @if (active.status === 'uploading' || active.status === 'processing' || active.status === 'stopping') {
              @if (active.upload_progress_mode === 'indeterminate' || active.status === 'stopping') {
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              } @else {
                <mat-progress-bar mode="determinate" [value]="active.upload_progress_percent"></mat-progress-bar>
              }
              @if (active.upload_status_label) {
                <span class="upload-status-label">{{ active.upload_status_label }}</span>
              }
            }
            @if (active.error_message) {
              <span class="error-text">{{ active.error_message }}</span>
            }
          </div>
          <div class="recording-actions">
            @if (canNavigateToMeetingRecord(active.recordable_type, active.recordable_id)) {
              <button mat-stroked-button type="button" (click)="navigateToMeetingRecord(active.recordable_id!)">Ir a reunión</button>
            }
            @if (active.status === 'recording') {
              <button mat-stroked-button type="button" (click)="pause()">Pausar</button>
              <button mat-stroked-button color="warn" type="button" (click)="stop()">Parar</button>
              <button mat-stroked-button type="button" (click)="discard()">Descartar</button>
            }
            @if (active.status === 'paused') {
              <button mat-stroked-button type="button" (click)="resume()">Reanudar</button>
              <button mat-stroked-button color="warn" type="button" (click)="stop()">Parar</button>
              <button mat-stroked-button type="button" (click)="discard()">Descartar</button>
            }
            @if (active.status === 'stopping') {
              <button mat-stroked-button color="warn" type="button" disabled>Deteniendo…</button>
            }
            @if (active.status === 'upload_failed' || active.status === 'pending_upload' || active.status === 'failed') {
              <button mat-stroked-button type="button" (click)="retry(active.client_local_id)">Reintentar</button>
              <button mat-stroked-button type="button" (click)="discardFailedUpload(active.client_local_id)">Descartar</button>
            }
            @if (
              active.status === 'completed' || active.status === 'failed' || active.status === 'uploading' || active.status === 'processing'
            ) {
              <button mat-stroked-button type="button" (click)="dismiss()">Cerrar</button>
            }
          </div>
        </div>
      }
    }
  } @else {
    @if (recording_service.recoverable_session$ | async; as recoverable) {
      <div class="recording-chip-wrapper">
        <div
          class="recording-chip is-recoverable"
          [matTooltip]="'Grabación interrumpida · ' + recoverable.concept + ' · ' + formatElapsed(recoverable.elapsed_seconds)"
        >
          <span class="recording-chip-dot"></span>
          <mat-icon>{{ recoverable.media_type === 'video' ? 'videocam' : 'mic' }}</mat-icon>
          <span class="recording-chip-label">Reanudar: {{ recoverable.concept }}</span>
          <span class="recording-chip-actions">
            <button mat-icon-button type="button" class="small-icon-button" matTooltip="Reanudar grabación" (click)="resumeInterrupted()">
              <mat-icon>play_arrow</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              class="small-icon-button"
              matTooltip="Descartar grabación interrumpida"
              (click)="abandonInterrupted()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </span>
        </div>
      </div>
    } @else {
      @if (recording_service.pending_uploads$ | async; as pending) {
        @for (item of pending; track item.client_local_id) {
          <div class="recording-popover is-pending">
            <mat-icon>cloud_upload</mat-icon>
            <div class="recording-info">
              <strong>{{ item.concept }}</strong>
              <span>Subida pendiente · {{ item.pending_chunk_indexes.length }} chunks</span>
            </div>
            <div class="recording-actions">
              @if (canNavigateToMeetingRecord(item.recordable_type ?? null, item.recordable_id ?? null)) {
                <button mat-stroked-button type="button" (click)="navigateToMeetingRecord(item.recordable_id!)">Ir a reunión</button>
              }
              <button mat-stroked-button type="button" (click)="retry(item.client_local_id)">Reintentar ahora</button>
              <button mat-stroked-button type="button" (click)="discardFailedUpload(item.client_local_id)">Descartar</button>
            </div>
          </div>
        }
      }
    }
  }
}
